import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSizeSetDeleted.meta';

export type UseTrackSizeSetDeletedParams = {
  source: 'context';
  member_count: number;
};

export const useTrackSizeSetDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackSizeSetDeleted = useCallback(
    (params: UseTrackSizeSetDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSizeSetDeleted };
};
